import { App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useGetTaskFormMutation } from 'store/features/process/processApi';

const START_TASK_ERROR_MESSAGE = 'Failed to open task form. Please try again.';

function useLaunchTaskForm() {
	const { message: messageApi } = App.useApp();
	const navigate = useNavigate();
	const { profileData = {} } = useSelector((state) => state.profile);
	const [getTaskForm, { isLoading }] = useGetTaskFormMutation();

	const launchTaskForm = async ({ processCode, codeTask, pathname }) => {
		if (!processCode || isLoading) return false;

		const creatorUserId = profileData?.userId;
		const creatorCompanyCode = profileData?.creatorOrganizationId;

		if (!creatorUserId || !creatorCompanyCode) {
			messageApi.error(START_TASK_ERROR_MESSAGE);
			return false;
		}

		try {
			const response = await getTaskForm({
				lynProcessCode: processCode,
				initLynTaskCode: codeTask,
				creatorUserId,
				creatorCompanyCode,
			}).unwrap();

			const stageId = response?.lynWorkflowInstanceStageId;
			if (!stageId) {
				messageApi.error(START_TASK_ERROR_MESSAGE);
				return false;
			}

			navigate('/process-form', {
				state: {
					stageId,
					processCode: response?.solutionTask?.processCode ?? processCode,
					pathname,
				},
			});

			return true;
		} catch (error) {
			messageApi.error(START_TASK_ERROR_MESSAGE);
			return false;
		}
	};

	return { launchTaskForm, isLaunchingTaskForm: isLoading };
}

export default useLaunchTaskForm;